import React, { useEffect, useState }  from 'react';
import { CsvButton,downloadCSV } from '../../../service/CsvButton';
import { ReactTableServerSide } from '../../ReactTableServerSide';
import auth from '../../../service/Auth';
import {files_view} from '../../../service/apis';
import ViewError from '../components/ViewError';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {GPAP_Button_light} from "../../../../gpap-lib/Button_Collection";
import Typography from '@mui/material/Typography';
import CustomizeColumns from "../components/CustomizeColumns";
import { header_files_config, files_search_delayed} from "../components/headers_config";
import settings from '../../../DataManagementConfig';


const config = window.config;

const FilesView = () => {

    const [headers, setHeaders] = useState(header_files_config);
    const [files, setFiles] = useState([]);
    const [errors, setErrors ] = useState("");
    const [pagination, setPagination] = useState({});
    const [tableColumns, setTableColumns ] = useState([]);
    const [headersTable, setHeadersTable] = useState([]);
    const [rowsTable, setRowsTable] = useState([])
    const [loadData, setLoadData] = useState(true);

    useEffect(() => {
        if (auth.tokenExpired()) {
            // Logging check
            setErrors("Logging session timeout. Please log again");
        }
        else {
            //Initialize Pagination 
            setPagination({
                page: 0, pages: 0, pageSize: 100,
                totalItems: 0,
                fields: [], filtered: [], sorted: []
            });
            // Get Fields from configured ones
            let stateHeaders = [];
            for (let field of config.file_view_fields){
                for (let header of headers) {
                    if (header.key === field) stateHeaders.push(header);
                }
            }
            setHeaders(stateHeaders);
        }
    },[])

  
    const loadTableData = (state,instance) => {
        // Method to call API Endpoint to get React Table Data
        setLoadData(true);
        // Get fields to be requiered
        let fields = [];
        for (let header of headers) {
            fields.push(header.key);
        }
        // Call API Endpoint
        let data_query = {
            "page" : (state.page + 1),
            "pageSize" : state.pageSize,
            "fields" : fields,
        }
        // Check filtered Criteria
        if (state.filtered) {
            data_query["filtered"] = state.filtered;
        }
        // Check sorted Criteria
        if (state.sorted) {
            data_query["sorted"] = state.sorted;
        }
        // Call POST Data
        files_view(auth.getToken(),config.api_endpoint, JSON.stringify(data_query))
        .then((response) => {
            return response.json()
        })
        .then((data) => {
            setFiles(data["items"]);
            setPagination({
                page : data["_meta"]["page"],
                pages : data["_meta"]["total_pages"],
                pageSize : data["_meta"]["page_size"],
                totalItems : data["_meta"]["total_items"],
                fields :fields,
                filtered : state.filtered,
                sorted : state.sorted
            });
            setLoadData(false);
        });
    };

    const updateColumns = (columns) => {
        let stateHeaders = [];
        for (let field of columns) {
            stateHeaders.push(header_files_config.find(item => item.key === field));
        } 
        setTableColumns(columns);
        setHeaders(stateHeaders);
    }

    const getTableHeaders = () => {
        let columns = [];
        for (let header of headers) {
            let column = {};
            if ("tooltip" in header){
                column["Header"] =  props => <span title={header.tooltip}>{header.label} <i className="fa fa-comment-o" aria-hidden="true"></i></span>;
            }
            else{
                column["Header"] = header.label;
            }
            column["accessor"] = header.key;
            column["minWidth"] = 220;
            columns.push(column);
        }
        // Column Filtering
        const allColumns = (tableColumns.length !== 0) ? columns.filter(s => tableColumns.includes(s.accessor)) : columns;
        setHeadersTable(allColumns);
    }
    
    const getDataTable = () => {
        // Build data to render table view
        let data = [];
        //TODO: Headers Table not updated
        for (let file of files) {
            let row = {};
            // 1. Loop Headers
            for (let column of headersTable){
                if (typeof file[column.accessor] === "boolean") row[column.accessor] = file[column.accessor].toString();
                else row[column.accessor] = file[column.accessor];
            }
            // 2. Add row to data
            data.push(row);
        }
        setRowsTable(data);
    }

    useEffect(() => {
        // Set headers
        getTableHeaders();
    },[files, tableColumns])

    useEffect(() => {
        // Set rows
        getDataTable();
    },[headersTable])

    const closeModal = () => {
        setErrors("");
    }

    const getCsvData = async (events) => {
        // Trigger Load Process
        setLoadData(true);
        // Get All Data to be printed to CSV Files
        let data_query = {
            "page" : 1,
            "pageSize" : settings.apiFilesCSVPageSize,
            "fields" : pagination.fields,
            "filtered" : pagination.filtered,
            "sorted": pagination.sorted
        }
        let getData = true;
        let allItems = []
        // Get All Data
        while (getData){
            // Call POST Data
            await files_view(auth.getToken(),config.api_endpoint, JSON.stringify(data_query))
            .then((response) => {
                return response.json()
            })
            .then((data) => {
                allItems.push(...data["items"]);
                if (data_query.page < data["_meta"]["total_pages"]){
                    getData = true;
                    data_query.page = data_query.page + 1;
                }
                else getData = false;
            })
        }
        // Build data for CSV
        let data = [];
        for (let item of allItems){
            let row = {};
            // 1. Loop Headers
            for (let header of headers) {
                  if (typeof item[header.key] === "boolean") row[header.key] = item[header.key].toString();
                  else row[header.key] = item[header.key];
            }
            // 2. Add row to data
            data.push(row);
        }
        // Call CSV File
        let today = new Date().toISOString().slice(0, 10);
        downloadCSV(data, headers,`${today}_file_list.csv`);
        setLoadData(false);
    }

    if (errors !== "") {
        // Show ViewError in case an error with the loggin occurs
        return <ViewError closeModal={closeModal} title={"Logging Error"} message={errors}/>;
    }
    else {
        return (
            <div className={"mainContent"}>
                <Typography variant={"h5"} align={"center"}> List of Uploaded Files </Typography>
                <GPAP_Button_light href = "#/management"  startIcon={<ArrowBackIcon />}>
                    Back
                </GPAP_Button_light>
                <CsvButton getCsvData={getCsvData} />
                <CustomizeColumns
                    type = {"files"}
                    updateColumns = {updateColumns}
                />
                <ReactTableServerSide
                    headers={headers}
                    columns={headersTable}
                    data={rowsTable}
                    pagination={pagination}
                    loadTableData={loadTableData}
                    fieldsDelay={files_search_delayed}
                    loading={loadData}
                />
            </div>
        );
    }
}

export default FilesView;

